/**
 * Constants for candidate search
 * Centralizing constants makes it easier to maintain and reuse them
 */
import { getAllSkills } from '../../../utils/skillsUtils';

// Search constants
export const CANDIDATES_PER_PAGE = 12;
export const DEBOUNCE_DELAY = 600;

// Experience level options
export const EXPERIENCE_LEVELS = [
  { value: 'entry', label: 'Entry Level (0-2 years)' },
  { value: 'intermediate', label: 'Intermediate (2-5 years)' },
  { value: 'senior', label: 'Senior (5+ years)' }
];

// Experience level mappings (for filtering)
export const EXPERIENCE_LEVEL_MAPPINGS = {
  'entry': [0, 2],
  'intermediate': [2, 5],
  'senior': [5, 10],
  'expert': [10, 100] // Upper limit for expert
};

// Availability options — values must match the availability_status column in user_profiles
export const AVAILABILITY_OPTIONS = [
  { value: 'available', label: 'Available Now' },
  { value: 'busy', label: 'Busy' },
  { value: 'unavailable', label: 'Unavailable' }
];

// Default hourly rate range
export const DEFAULT_HOURLY_RATE_RANGE = {
  min: 10,
  max: 100
};

// Skill options
export const SKILL_OPTIONS = getAllSkills();

// Rating options
export const RATING_OPTIONS = [
  { value: '4', label: '4+ Stars' },
  { value: '4.5', label: '4.5+ Stars' },
  { value: '5', label: 'Only 5 Stars' }
];

// View mode options
export const VIEW_MODES = {
  GRID: 'grid',
  LIST: 'list'
};

// Local storage keys
export const STORAGE_KEYS = {
  VIEW_MODE: 'candidateViewMode',
  FILTERS: 'candidateSearchFilters',
  RECENT_SEARCHES: 'recentCandidateSearches'
};

// Analytics event names
export const ANALYTICS_EVENTS = {
  SEARCH: 'candidate_search',
  PROFILE_VIEW: 'view_candidate_profile',
  SAVE_CANDIDATE: 'save_candidate',
  UNSAVE_CANDIDATE: 'unsave_candidate',
  CONTACT_CANDIDATE: 'contact_candidate',
  APPLY_FILTER: 'apply_candidate_filter',
  CHANGE_VIEW_MODE: 'change_view_mode',
  LOAD_MORE: 'load_more_candidates',
  CLEAR_FILTERS: 'clear_all_filters'
};

// Error messages
export const ERROR_MESSAGES = {
  LOAD_FAILED: 'Failed to load candidates. Please try again.',
  SAVE_FAILED: 'Failed to save candidate. Please try again.',
  AUTH_REQUIRED: 'Please sign in to access this feature.',
  EMPLOYER_ONLY: 'Only employers can access this feature.',
  CONTACT_FAILED: 'Failed to send message. Please try again.',
  GENERAL: 'An unexpected error occurred. Please try again.'
};

export default {
  CANDIDATES_PER_PAGE,
  DEBOUNCE_DELAY,
  EXPERIENCE_LEVELS,
  EXPERIENCE_LEVEL_MAPPINGS,
  AVAILABILITY_OPTIONS,
  DEFAULT_HOURLY_RATE_RANGE,
  SKILL_OPTIONS,
  RATING_OPTIONS,
  VIEW_MODES,
  STORAGE_KEYS,
  ANALYTICS_EVENTS,
  ERROR_MESSAGES
};